/**
 * A day's cells — 96 fifteen-minute slots as one string per lane, written by
 * the activity store (SW-8879) — become the segments a lane draws: runs of
 * equal slots, each as a share of the day. Readiness: `R` ready, `N` not
 * ready, `U` no mark. Activity: `B` busy, `A` available, `O` offline. `.` (or
 * anything unknown) is "not yet": a slot the clock or the lake has not reached.
 */

export type LaneKind = "readiness" | "activity";

/** The class a segment paints with; the lanes' stylesheets key on it. */
export type SegmentClass = "f" | "n" | "u" | "t" | "b" | "a" | "o";

export interface Segment {
  cls: SegmentClass;
  /** Percent of the day, two decimals. */
  w: number;
}

const READINESS: Record<string, SegmentClass> = { R: "f", N: "n", U: "u" };
const ACTIVITY: Record<string, SegmentClass> = { B: "b", A: "a", O: "o" };

const round = (n: number) => Math.round(n * 100) / 100;

export function segmentsFromCells(
  cells: string | undefined,
  kind: LaneKind,
): Segment[] {
  if (!cells) return [{ cls: "t", w: 100 }];
  const map = kind === "readiness" ? READINESS : ACTIVITY;
  const out: Segment[] = [];
  let current: SegmentClass | null = null;
  let run = 0;
  const flush = () => {
    if (current !== null && run > 0) {
      out.push({ cls: current, w: round((run / cells.length) * 100) });
    }
  };
  for (const ch of cells) {
    const cls = map[ch] ?? "t";
    if (cls !== current) {
      flush();
      current = cls;
      run = 0;
    }
    run += 1;
  }
  flush();
  return out;
}
